import { Icon } from '@iconify/react'
import { Lock } from 'lucide-react'

const Disclaimers = () => {
  return (
    <div className="px-4 py-6">
      <div className="bg-gray-100 rounded-lg p-4 space-y-4">
        <div className="flex items-start gap-3">
          <Lock className="text-gray-600 mt-1 flex-shrink-0" size={20} />
          <div>
            <h3 className="font-semibold text-black mb-1">개인정보 보호</h3>
            <p className="text-sm text-gray-600">
              업로드된 계약서는 분석 후 즉시 파기됩니다
            </p>
          </div>
        </div>
        
        <div className="flex items-start gap-3">
          <Icon icon="solar:info-circle-bold" className="text-gray-600 mt-1 flex-shrink-0" width={20} height={20} />
          <div>
            <h3 className="font-semibold text-black mb-1">참고용 서비스</h3>
            <p className="text-sm text-gray-600">
              법적 효력이 없는 참고용 서비스입니다. 중요한 계약은 반드시 전문가와 상담하세요
            </p>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Disclaimers

